
  import { defineComponent } from 'vue';
  import { PropType } from 'vue/dist/vue';

  import { TSelectOption } from '@/common/types/select';

  import { TUploadingStatus } from './types';

  export default defineComponent({
    name: 'UploadingStatus',
    props: {
      info: {
        type: Object as PropType<TUploadingStatus | null>,
        required: true,
      },
    },
    computed: {
      getMainInfo(): TSelectOption[] {
        const result: TSelectOption[] = [];

        if (this.info?.processedRows) {
          result.push({
            value: this.info.processedRows,
            label: 'Успешно загружено записей',
          });
        }

        if (this.info?.missingRows) {
          result.push({
            value: this.info.missingRows,
            label: 'Пропущено записей',
          });
        }

        return result;
      },
    },
  });
